const ALLOWED_TAGS = new Set([
  "P", "BR", "STRONG", "B", "EM", "I", "U", "S", "UL", "OL", "LI",
  "A", "SPAN", "DIV", "BLOCKQUOTE", "PRE", "CODE", "H1", "H2", "H3", "H4", "HR",
]);
const BLOCKED_TAGS = "script,style,iframe,object,embed,form,input,button,select,textarea,link,meta,svg,math,template";

export const sanitizeHtml = (value = "") => {
  if (typeof value !== "string") return "";
  const documentNode = new DOMParser().parseFromString(value, "text/html");
  documentNode.querySelectorAll(BLOCKED_TAGS).forEach((element) => element.remove());
  documentNode.body.querySelectorAll("*").forEach((element) => {
    if (!ALLOWED_TAGS.has(element.tagName)) {
      element.replaceWith(...element.childNodes);
      return;
    }
    Array.from(element.attributes).forEach(({ name, value: attributeValue }) => {
      if (name === "data-copy-code" || name === "title") return;
      if (element.tagName === "A" && name === "href") {
        try {
          const url = new URL(attributeValue, "https://localhost/");
          if (["http:", "https:", "mailto:", "tel:"].includes(url.protocol)) return;
        } catch (error) {
          // Invalid URLs are removed with other unsupported attributes.
        }
      }
      element.removeAttribute(name);
    });
    if (element.tagName === "A") element.setAttribute("rel", "noopener noreferrer");
  });
  return documentNode.body.innerHTML;
};
